export const en = {
    home: "Home",
    signUp: "Sign Up",
    login: "Log in",
    getOtp: "Send 6 - Digit Code",
    back: "Back",
    verify: "Verify",
    verifyOtp: "Verify Code",
    submit: "Submit",
    clear: "Clear",
    register: "Register",
    aboutUs: "About Us",
    contactUs: "Contact Us",
    howItWorks: "How it Works",
    feedback: "Feedback",
    partners: "Partners",
    administrators: "Administrators",
    dealers: "Dealers",
    existingdealers: "Existing Dealers",
    roleManagement: "Role Management",
    inventory: "Inventory",
    bids: "Bid",
    product: "Product Details",
    update: "Update",
    cancel: "Cancel",
    yes: "Yes",
    no: "No",
    ok: "Ok",
    add: "Add",
    view: "View",
    edit: "Edit",
    delete: "Delete",
    loginSuccess: "Login Successful",
    signupSuccess: "Signup Successful",
    useraddedSuccess: "User Added Successful",
    somethingWentWrong: "Something Went Wrong",
    internalServerError: "Internal Server Error",
    pleaseSelectLicenseDocument: "Please Select License Document",
    fileSizeLimit: "File size exceeds the 6MB limit.",
    selectRole: "Select User",
    areYouSure: "Are you sure you want to save changes?",
    areYouWantToLogout: "Are you sure you want to log out?",
    areYouWantToDelete: "Are you sure you want to Delete?",
    areYouWantToDeactivate: "Are you sure you want to Deactivate?",
    DeleteDealerAdmin: "Please select Dealer Admin before deleting.",
    dontHaveAccount: "Don't have an account?",
    getBackToYou: "Thank you for reaching out! Your message has been successfully submitted.",
    approveUser: "Approve User",
    dashboard: "You are not allowed to access this page.",
    addNote: "Add  Note"
};
